'use client'

import { useLocale } from 'next-intl'
import { useMemo } from 'react'
import { MarketingVideo } from '@/features/marketing-videos/marketing-video'
import { Language, parseLanguageFromLocale } from '@/setup/locales'
import { cn } from '@/utils/styles/cn'

const VIDEO_SOURCES: Record<Language, Record<'src' | 'thumbnail', string>> = {
    [Language.DE]: {
        src: 'https://wrxnld43zzfiiudl.public.blob.vercel-storage.com/neotaste-explanation-de-We3M8Vc4Tn8D2isMs6gYQbxzUGSH4b.mp4',
        thumbnail: '/_images/neotaste-explanation/neotaste-explanation-thumbnail-de.png',
    },
    [Language.EN]: {
        src: 'https://wrxnld43zzfiiudl.public.blob.vercel-storage.com/neotaste-explanation-en-mJx3zc8gmXPKslAbmzqVzi7S95WPx3.mp4',
        thumbnail: '/_images/neotaste-explanation/neotaste-explanation-thumbnail-nl-en.webp',
    },
    [Language.NL]: {
        src: 'https://wrxnld43zzfiiudl.public.blob.vercel-storage.com/neotaste-explanation-nl-7IxWPUOU3Iy75XlRKcxCCr7IodxAIL.mp4',
        thumbnail: '/_images/neotaste-explanation/neotaste-explanation-thumbnail-nl-en.webp',
    },
}

export const NeotasteExplanationVideo = ({ className }: { className?: string }) => {
    const locale = useLocale()

    const language = useMemo(() => parseLanguageFromLocale(locale), [locale])

    const videoSrc = useMemo(() => VIDEO_SOURCES[language], [language])

    if (!videoSrc) return null

    return (
        <MarketingVideo
            aspectRatio={774 / 436}
            src={videoSrc.src}
            className={cn(
                `max-w-[90vw] min-w-[90vw] max-h-[50vw] min-h-[50vw] md:max-w-[70vw] md:min-w-[70vw]
                md:max-h-[39.5vw] md:min-h-[39.5vw]`,
                className
            )}
            thumbnail={videoSrc.thumbnail}
            isPlaying={undefined}
        />
    )
}
